import React from "react";

import ListBody from "./ListBody";

import Paginator, { FIRST_PAGE } from "./Paginator";
import { isNaN } from "lodash";
import { Link } from "react-router-dom";
import QueryString from "qs";
import { Renderer } from "../descriptors/common";
import { Box, Table, TableCell, TableFooter, TableHead, TableRow } from "@mui/material";
import { FormattedMessage } from "react-intl";

const UPARROW = " \u25b2";
const DOWNARROW = " \u25bc";

enum Direction {
    ASCENDING = "asc",
    DESCENDING = "desc",
}

export type ListProps = {
    data: any[];
    header: string[];
    maxPage?: number;
    renderers?: Record<string, Renderer>;
    uri: URL;
    fieldNameKeyFactory?: (fieldName: string) => string;
    collapseRenderer?: (row: any) => React.ReactNode | null;
};

function uriWithPage(uri: URL, page: number): URL {
    const res = new URL(uri); // copy
    res.searchParams.set("page", page.toString());
    return res;
}

export default class List extends React.Component<ListProps> {
    static defaultProps = {
        fieldNameKeyFactory: (fieldName: string) => fieldName,
    };

    constructor(props: ListProps) {
        super(props);
    }

    private buildOrderUri(field: string, direction: Direction) {
        const params = QueryString.parse(this.props.uri.search, { ignoreQueryPrefix: true });
        params.sort = {
            name: field,
            direction: direction,
        };
        const uri = new URL(this.props.uri); // copy
        uri.search = QueryString.stringify(params, { addQueryPrefix: true });
        return uri;
    }

    _renderDefaultHeaderElement(element: string, orderable: boolean = true) {
        const fieldKey = this.props.fieldNameKeyFactory(element);
        // eslint-disable-next-line formatjs/enforce-default-message, formatjs/enforce-id
        const displayName = <FormattedMessage id={fieldKey} />;
        if (orderable === false) {
            return <TableCell>displayName</TableCell>;
        }
        let direction = Direction.ASCENDING;
        let arrow = "";
        const params = QueryString.parse(this.props.uri.search, { ignoreQueryPrefix: true });
        if ("sort" in params) {
            const sort: any = params.sort;
            if (sort.name == element) {
                if (sort.direction === Direction.ASCENDING) {
                    arrow = UPARROW;
                    direction = Direction.DESCENDING;
                } else {
                    arrow = DOWNARROW;
                    direction = Direction.ASCENDING;
                }
            }
        }
        const uri = this.buildOrderUri(element, direction);
        return (
            <TableCell>
                <Link to={{ pathname: uri.pathname, search: uri.search }}>{displayName}</Link>
                <Box component="span" sx={{ color: "primary.main" }}>
                    {arrow}
                </Box>
            </TableCell>
        );
    }

    constructHeader() {
        const headerCells = [];

        if (this.props.collapseRenderer) {
            headerCells.push(<TableCell key="collapseHeader" />);
        }

        for (const element of this.props.header) {
            headerCells.push(this._renderDefaultHeaderElement(element));
        }

        return headerCells;
    }

    render() {
        const header = this.constructHeader();

        let currentPage = FIRST_PAGE;
        if (this.props.uri.searchParams.has("page")) {
            const page = Number(this.props.uri.searchParams.get("page"));
            console.debug("page", page);
            if (!isNaN(page)) currentPage = page;
        }

        return (
            <Table>
                <TableHead>
                    <TableRow>{...header}</TableRow>
                </TableHead>
                <ListBody
                    data={this.props.data}
                    header={this.props.header}
                    renderers={this.props.renderers}
                    collapseRenderer={this.props.collapseRenderer}
                />
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={100}>
                            <Paginator uri={uriWithPage(this.props.uri, currentPage)} maxPage={this.props.maxPage} />
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        );
    }
}
